// extracted by mini-css-extract-plugin
export default {"header":"nav_header__ll-Kj","company":"nav_company__60b4n","navLink":"nav_navLink__pHvqw","logo":"nav_logo__hW-d7"};